import React, { useState, useEffect, useContext } from 'react';
import { Table } from 'react-bootstrap';
import ENDPOINT from '../../context/EndPoint';
import { AuthContext } from '../../context/AuthContext';
import { Avatar } from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';

TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo('en-US');

const RecentDoubts = () => {
    const [doubts, setDoubts] = useState(null);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (!user || !user.SessionId) return;

        const formData = new FormData();
        formData.append('session', user.SessionId);

        fetch(`${ENDPOINT}get_recent_doubts.php`, {
            method: 'POST',
            body: formData,
        })
            .then(res => res.json())
            .then(data => setDoubts(data))
            .catch(err => {
                console.error('Fetch error:', err);
                setDoubts({ status: 'error', message: 'Failed to fetch doubts' });
            });
    }, [user]);

    if (!doubts) return <div>Loading...</div>;
    if (doubts.status === 'error') return <div>{doubts.message}</div>;

    return (
        <div>
            <h2>Recent Doubts (15-30 min ago)</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>User</th>
                        <th>Subject</th>
                        <th>Message</th>
                        <th>Status</th>
                        <th>Category</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {doubts.data.length === 0 ? (
                        <tr>
                            <td colSpan="6">No doubts found</td>
                        </tr>
                    ) : (
                        doubts.data.map(doubt => (
                            <tr key={doubt.id}>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {doubt.user?.profile_pic ? (
                                            <Avatar src={doubt.user.profile_pic} alt="Profile" />
                                        ) : (
                                            <Avatar>{doubt.user?.first_name?.[0] || 'U'}</Avatar>
                                        )}
                                        <div className="ms-2">
                                            <p className="mb-0">
                                                {doubt.user?.first_name} {doubt.user?.last_name}
                                            </p>
                                            <p className="mb-0">
                                                {doubt.user?.phone_number || 'N/A'}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td>{doubt.subject}</td>
                                <td>{doubt.message}</td>
                                <td>{doubt.status}</td>
                                <td>{doubt.category}</td>
                                <td>
                                    {doubt.create_datetime 
                                        ? timeAgo.format(new Date(doubt.create_datetime)) 
                                        : 'N/A'}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default RecentDoubts;